import { createPortal } from "react-dom";
import clsx from "clsx";
import Button from "./Button";

const portalTarget = typeof document !== "undefined" ? document.body : null;

export default function Modal({
  title,
  children,
  onClose,
  size = "md", // "sm" | "md" | "lg" | "xl"
  showClose = true,
  contentClassName = "",
  scrollable = true,
}) {
  if (!portalTarget) return null;

  const maxWidth = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-2xl",
    xl: "max-w-5xl",
  }[size];

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget && onClose) {
      onClose();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/50 backdrop-blur-sm p-2 sm:p-4"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className={clsx(
          "bg-white rounded-2xl shadow-2xl w-full mx-2 p-4 sm:p-5 relative z-[10000] flex flex-col",
          scrollable && "max-h-[90vh]",
          maxWidth,
          contentClassName
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {showClose && (
          <Button
            variant="secondary"
            size="sm"
            onClick={onClose}
            className="absolute top-3 right-3 !px-2 !py-1"
          >
            ✕
          </Button>
        )}
        {title && (
          <div className="flex flex-wrap justify-between items-center gap-3 border-b pb-2 mb-4 pr-8">
            <h3 className="font-bold text-base sm:text-lg">{title}</h3>
          </div>
        )}
        <div className={clsx(scrollable && "flex-1 overflow-y-auto pr-1 sm:pr-0")}>
          {children}
        </div>
      </div>
    </div>,
    portalTarget
  );
}
